$(document).ready(function () {

    $('body').on('click', 'a[href="#request_a_demo"]', function (e) {
        e.preventDefault();
        let modal = '#request_a_demo'
        if (!$(modal).hasClass('open')) {
            $(modal).addClass('open').fadeIn(500);
        }
    });
    $('body').on('click', '[data-modal]', function (e) {
        e.preventDefault();
        let that = $(this);
        let modal = that.data('modal')
        if (!$(modal).hasClass('open')) {
            $(modal).addClass('open').fadeIn(500);
        }
    });
    $('body').on('click', '.modal__close', function (e) {
        e.preventDefault();
        let that = $(this);
        that.closest('.wrapper_modal').removeClass('open').fadeOut(500);
        $('form').trigger('reset');
        $('.wpcf7-form').closest('.modal').find('.modal__title').show();
        $('.wpcf7-form').closest('.modal').find('.modal__content-info').show();
    });
    $('body').on('click', '.modal', function (e) {
        e.stopPropagation();
    });
    $('body').on('click', '.backdrop', function (e) {
        e.preventDefault();
        $('.wrapper_modal').removeClass('open').fadeOut(500);
        $('form').trigger('reset');
        $('.wpcf7-form').closest('.modal').find('.modal__title').show();
        $('.wpcf7-form').closest('.modal').find('.modal__content-info').show();
    });
    // $('body').on('click', '.wrapper_modal', function (e) {
    //     e.preventDefault();
    //     let that = $(this);
    //     that.removeClass('open').fadeOut(500);
    //     $('form').trigger('reset');
    //     $('.wpcf7-form').closest('.modal').find('.modal__title').show();
    //     $('.wpcf7-form').closest('.modal').find('.modal__content-info').show();
    // });

});

document.addEventListener( 'wpcf7submit', function( event ) {
    $('.wpcf7-form.sent').closest('.modal').find('.modal__title').hide()
    $('.wpcf7-form.sent').closest('.modal').find('.modal__description').hide()
    $('.wpcf7-form.sent').closest('.modal').find('.modal__content-info').hide()
}, false );

$(document).ready(function () {
    $(document).ready(function () {
        $('input[type="number"]').on('keypress', function (e) {
            const char = String.fromCharCode(e.which);
            if (!/[\d]/.test(char)) return; // Разрешаем только цифры

            const $input = $(this);
            const min = parseInt($input.attr('min'), 10);
            const max = parseInt($input.attr('max'), 10);

            // Текущее значение + символ, который пытается ввести пользователь
            const proposedValue = $input.val() + char;
            const numericValue = parseInt(proposedValue, 10);

            if (proposedValue.length > max.toString().length || isNaN(numericValue)) {
                e.preventDefault(); // слишком длинное или нечисловое значение
                return;
            }

            if (numericValue > max) {
                e.preventDefault(); // запретить ввод, если вышли за границы
            }
        });
    });


});